import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { close: Boolean }

  connect() {
    if (this.closeValue) this.close()
  }

  open() {
    this.modalBootstrap = new bootstrap.Modal(document.getElementById('modal')) 
    this.modalEl = document.getElementById('modal')
    this.modalBootstrap = bootstrap.Modal.getInstance(this.modalEl)
    this.modalBootstrap.show()
  }
  
  close() {
    this.modalEl = document.getElementById('modal')
    this.modalBootstrap = bootstrap.Modal.getInstance(this.modalEl)
    this.modalBootstrap.toggle()
  }
}
